<template>
  <section class="featuresSection">
    <div class="featuresSectionContent">
      <InfographicSection
        :button-text="'Get started'"
        :has-inverted-layout="true"
        :has-white-text="true"
        :on-button-click="() => onRedirect('PodcasterRegister')"
        :paragraph="'Make your content available anywhere on the web with our fully customizable web player.'"
        :title="'Embed your podcast on any website'"
        class="featuresInfoSection"
      >
        <video
          v-if="isNarrowViewport"
          :poster="`static/videos/embed-player-poster.576p.webp`"
          class="video"
          loop
          muted
          playsinline
          preload="none"
        >
          <source :src="`static/videos/embed-player.576p.av1.qp100.mp4`" type="video/mp4; codecs=av01.0.05M.08" />
          <source :src="`static/videos/embed-player.576p.hevc.crf28.mp4`" type="video/mp4; codecs=hvc1" />
          <source :src="`static/videos/embed-player.576p.avc.crf28.mp4`" type="video/mp4; codecs=avc1.4D401E" />
        </video>
        <video
          v-else
          :poster="`static/videos/embed-player-poster.576p.webp`"
          class="video"
          loop
          muted
          playsinline
          preload="none"
        >
          <source :src="`static/videos/embed-player.1152p.av1.qp80.mp4`" type="video/mp4; codecs=av01.0.05M.08" />
          <source :src="`static/videos/embed-player.1152p.hevc.crf24.mp4`" type="video/mp4; codecs=hvc1" />
          <source :src="`static/videos/embed-player.1152p.avc.crf24.mp4`" type="video/mp4; codecs=avc1.4D401E" />
        </video>
      </InfographicSection>
    </div>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router/composables'
import { bool } from 'vue-types'

import InfographicSection from 'components/reused-components/infographicSection/InfographicSection'

defineProps({
  isNarrowViewport: bool().isRequired,
})

const router = useRouter()

const onRedirect = (routeName) => {
  router.push({ name: routeName })
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/bootstrap_variables';
@import 'assets/scss/base/functions';

.featuresSection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1440px;
  padding: 0 16px;
  margin: 88px auto 0;

  @media (min-width: $screen-sm-min) {
    padding: 0 32px;
    margin: 120px auto 0;
  }

  .featuresSectionContent {
    display: flex;
    flex-direction: column;
    width: 100%;

    .featuresInfoSection {
      margin-top: 56px;

      @media (min-width: $screen-sm-min) {
        margin-top: 80px;
      }
    }

    .video {
      width: 100%;
      max-width: 576px;
      margin: 0 auto 32px;
      pointer-events: none;
      border-radius: 12px;

      @media (min-width: $screen-sm-min) {
        max-width: 90%;
        margin: 0;
      }

      @media (min-width: $screen-xl-min) {
        max-width: 768px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// FeaturesSecondSection.vue